import EmberRouter from '@embroider/router';
import config from 'favoris-web/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  // Public catalog browse
  this.route('explore', function () {
    this.route('index', { path: '/' }, function () {
      // eslint-disable-next-line ember/no-shadow-route-definition -- layout route wrapping results
      this.route('results', { path: '/' });
    });
    this.route('show', { path: '/:item_id' });
    this.route('recipe', { path: '/recipe/:recipe_id' });
  });
  this.route('places');
  this.route('search');
  this.route('login');
  this.route('auto-login');
  this.route('verified');

  // Authenticated user routes
  this.route('extract');
  this.route('share');
  this.route('items', function () {
    this.route('show', { path: '/:item_id' });
  });
  this.route('sources', function () {
    this.route('show', { path: '/:source_id' });
  });
  this.route('my-account');
  this.route('link-account');
  this.route('collections');

  this.route('not-found', { path: '/*path' });
});
